import { useFormik } from "formik";
import { useState } from 'react';
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { KTIcon } from "../../../../../_metronic/helpers";
import { Pagination } from "../../../../components/common/pagination/Pagination";
import { EmptySection } from "../../../../components/sections/empty/Empty";
import { LoaderSection } from "../../../../components/sections/loader/Loader";
import { useDeleteModal } from "../../../../context/DeleteModalContext";
import { useNotification } from "../../../../context/NotificationContext";
import { LANGUAGES } from "../../../../mock/languages";
import { MODERATOR_VICTIM_TYPE } from "../../../../mock/URLs";
import { createVictimType, getVictimTypeById, getVictimTypes, updateVictimType } from "../../../../services/victimSvc";
import { lang } from "../../../../types/lang";

export const VictimTypeCreatePage = () => {
  const [activeTab, setActiveTab] = useState<lang>("uz");
  const {showNotification} = useNotification()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const [selectedType, setSelectedType] = useState<number | null>(null)
  const {
    data: typeById,
  } = useQuery(["getVictimTypeById", selectedType], () => getVictimTypeById(selectedType!), {
    enabled: !!selectedType
  })

  const {
    data: victimTypes,
    isLoading: victimIsLoading,
    refetch: refetchVictimTypes
  } = useQuery(["getVictimTypes", page], () => getVictimTypes({
    params: {
      page,
      page_size: 1000
    }
  }))

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: {
        uz: typeById?.name_uz || '',
        ru: typeById?.name_ru || '',
        en: typeById?.name_en || '',
      }
    },
    onSubmit: async (values, {resetForm}) => {
      try {
        const transformedValues = {
          name_uz: values.name.uz,
          name_ru: values.name.ru,
          name_en: values.name.en
        }
        if (selectedType) {
          await updateVictimType(selectedType!, transformedValues)
          showNotification("Muvaffaqiyatli", "Viktimlik turi yangilandi", "success")
          setSelectedType(null)
        } else {
          await createVictimType(transformedValues)
          showNotification("Muvaffaqiyatli", "Viktimlik turi qo'shildi", "success")
        }
        refetchVictimTypes()
        resetForm()
      } catch (e) {
        showNotification("Xatolik", "", "error")
      }
    }
  })


  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  const totalItems = victimTypes?.total_items || 0;
  const itemsPerPage = victimTypes?.page_size || 8;


  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_VICTIM_TYPE, id, refetchVictimTypes);
  };

  return (
      <div>
        <div className={"card"}>
          <div className="card-header">
            <h1 className="card-title">Viktimlik tur qo'shish</h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="card-body">
              <div className="row mb-6">
                <label className="col-lg-4 col-form-label required fw-bold fs-6">
                  Viktimlik turi
                </label>
                <div className="col-lg-8 fv-row">
                  <input
                      type={"text"}
                      className="form-control form-control-lg form-control-solid"
                      placeholder="Viktimlik turi"
                      name={`name.${activeTab}`}
                      value={formik.values.name[activeTab]}
                      onChange={formik.handleChange}
                  />
                  {formik.touched.name?.[activeTab] && formik.errors.name?.[activeTab] && (
                      <div className="text-danger">{formik.errors.name?.[activeTab]?.toString()}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-footer text-end">
              <button disabled={formik.isSubmitting || !formik.dirty || !formik.isValid
              } type="submit" className="btn btn-primary">
                {formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"}
              </button>
            </div>
          </form>
        </div>

        <div className="card mt-10">
          <div className="card-header">
            <h3 className="card-title">Mavjud viktimlik turlar</h3>
          </div>
          <div className="card-body">
            {victimIsLoading ? <LoaderSection height={"30vh"}/> : victimTypes?.data.length === 0 ?
                <EmptySection height={"30vh"}/> : <table className="table table-bordered table-hover">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Viktimlik tur</th>
                    <th>Amallar</th>
                  </tr>
                  </thead>
                  <tbody>
                  {victimTypes?.data?.map((type, index) => (
                      <tr key={type.id}>
                        <td>{index + 1}</td>
                        <td>{type?.name}</td>
                        <td>
                          <button onClick={
                            () => setSelectedType(type.id)
                          } className="btn btn-light-primary btn-sm">O'zgartirish
                          </button>
                          <button onClick={() => handleDeleteClick(type.id)}
                                  className="btn btn-danger btn-icon btn-sm ms-1">
                            <KTIcon iconName={"trash-square"} className={"fs-1"}></KTIcon>
                          </button>
                        </td>
                      </tr>
                  ))}
                  </tbody>
                </table>}
          </div>

          {Boolean(totalItems) && <div className={"card-footer"}>
              <Pagination
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
              />
          </div>}
        </div>
      </div>
  )
}
